(function () {
  function init() {
    const popup = document.querySelector('.notification');
    if (!popup || popup.dataset.tbrcReady) return;
    popup.dataset.tbrcReady = 'true';
    const key = 'tbrcNewsletterDismissedAt';
    const sessionKey = 'tbrcNewsletterShown';
    const duration = 14 * 86400000;
    const read = (storage, name) => { try { return storage.getItem(name); } catch (e) { return null; } };
    const write = (storage, name, value) => { try { storage.setItem(name, value); } catch (e) {} };
    const dismiss = () => {
      popup.classList.remove('open');
      popup.classList.add('close');
      write(localStorage, key, String(Date.now()));
      write(sessionStorage, sessionKey, '1');
    };
    popup.querySelector('.notification__btn')?.addEventListener('click', dismiss);
    document.querySelector('.notification-overlay')?.addEventListener('click', dismiss);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && popup.classList.contains('open')) dismiss(); });
    if (popup.querySelector('.notification-form__success')) {
      popup.classList.remove('close');
      popup.classList.add('open');
      write(sessionStorage, sessionKey, '1');
      return;
    }
    if (read(sessionStorage, sessionKey) || Date.now() - Number(read(localStorage, key) || 0) < duration || /\/cart(?:\/|$)/.test(location.pathname)) return;
    setTimeout(() => {
      if (document.querySelector('cart-drawer.active, cart-notification.active, dialog[open]')) return;
      popup.classList.remove('close');
      popup.classList.add('open');
      write(sessionStorage, sessionKey, '1');
    }, Math.min(30, Math.max(20, Number(popup.dataset.timeout) || 25)) * 1000);
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(() => { if (drawer.classList.contains('active') && popup.classList.contains('open')) dismiss(); }).observe(drawer, {attributes:true,attributeFilter:['class']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();